_ = require 'underscore'
CustomFieldCardDetailBadgeView = require 'views/custom-field/custom-field-card-detail-badge-view'
Keyboard = require 'lib/keyboard'
Util = require 'lib/util'
t = require('views/internal/teacup-with-helpers')()

module.exports = class CustomFieldNumberCardDetailBadgeView extends CustomFieldCardDetailBadgeView
  template: t.renderable ({ icon, name, text, editable, color } = {}) ->
    t.h3 '.card-detail-item-header', ->
      t.icon icon
      t.text name

    if editable
      t.input '.card-detail-badge.is-clickable.js-custom-field-detail-badge' + color,
        autocomplete: 'off'
        'data-lpignore': true
        maxlength: 256
        size: Math.max text.length + 2, 7
        title: text
        type: 'text'
        value: text

    t.span '.card-detail-badge' + color,
      class: t.classify({ 'printable-badge': editable })
      title: text
    , ->
      t.text text

  getBadgeText: ->
    @customFieldItem?.get('value')?.number || ''

  events:
    'keyup .js-custom-field-detail-badge': 'validateNumber'
    'keydown .js-custom-field-detail-badge': 'handleEnter'
    'focusin .js-custom-field-detail-badge': 'startEditCustomFieldBadgeText'
    'focusout .js-custom-field-detail-badge.js-is-editing': 'editCustomFieldBadgeText'

  startEditCustomFieldBadgeText: (e) ->
    @track()
    e.target.classList.add('js-is-editing')

  validateNumber: (e) ->
    current = e.target.value.trim()
    if isNaN current
      e.target.classList.add('is-invalid')
    else
      e.target.classList.remove('is-invalid')

  handleEnter: (e) ->
    if Keyboard.isSubmitEvent(e)
      @$(e.target).blur()

  editCustomFieldBadgeText: (e) ->
    Util.stop(e)
    e.target.classList.remove('js-is-editing')
    e.target.classList.remove('is-invalid')
    newVal = e.target.value.trim()
    e.target.value = newVal

    if !@customFieldItem?
      if newVal && !isNaN(newVal)
        @model.customFieldItemList.create({
          idCustomField: @customField.id
          idModel: @model.id
          modelType: 'card'
          value:
            number: newVal
        })
      if isNaN newVal
        e.target.value = ''
      return

    oldVal = @customFieldItem.get('value')?.number || ''
    # check to see if the value has changed
    if newVal == oldVal
      return

    if newVal == ''
      @customFieldItem.clearValue()
    else
      # only update if the number is valid
      if !isNaN(newVal)
        @customFieldItem.setValue({ number: newVal })
      else
        e.target.value = oldVal



// WEBPACK FOOTER //
// ./app/scripts/views/custom-field/custom-field-number-card-detail-badge-view.coffee